import { FunctionComponent } from 'react'
import styles from './filterMobileDialog.module.scss'
import { SelectOptionsDeprecated } from '@/types/Select'
import Dialog from '@/components/_custom/Dialog/Dialog'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import SelectMultiple from '@/components/_custom/Selector/selectMultiple/selectMultiple'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'

interface FilterMobileDialogProps {
    open: boolean
    handleClose: () => void
    selectFilters: string[]
    filterEvents: (filters: string[]) => void
    selectFiltersOptions: SelectOptionsDeprecated
    isParent: boolean
}

const FilterMobileDialog: FunctionComponent<FilterMobileDialogProps> = ({
    open,
    handleClose,
    selectFilters,
    filterEvents,
    selectFiltersOptions,
    isParent
}) => {
    const { t } = useTranslation()

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('filter')} parent={isParent} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.Container}>
                    <SelectMultiple
                        selectOptions={selectFiltersOptions}
                        selectValues={selectFilters}
                        setSelectValues={filterEvents}
                        isParent={isParent}
                    />
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} parent={isParent} className={styles.Button} />
                    {selectFilters.length > 0 && (
                        <ButtonTextIcon
                            type={'reset'}
                            onClick={() => filterEvents([])}
                            parent={isParent}
                            className={styles.Button}
                        />
                    )}
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default FilterMobileDialog
